function isWindow(value) {
    if (value) {
        // The window object has a `self` and a `window` property that both refers to itself
        return value === value.self && value === value.window;
    }
    return false;
}

export { isWindow };
